// extracted by mini-css-extract-plugin
export default {"svg_button":"svg-button_svg_button__Wud7Z"};